import type { Tracker } from '../tracker'

export function consoleTracker(): Tracker {
  return {
    track(event, payload, ctx) {
      // eslint-disable-next-line no-console
      console.log('[analytics]', event, payload, ctx)
    },
    identify(userId, traits) {
      // eslint-disable-next-line no-console
      console.log('[analytics][identify]', userId, traits || {})
    },
  }
}
